import { createContext, useContext, useEffect, useState, useRef } from 'react'
import { supabase } from '../lib/supabase'
const AuthContext = createContext(null)
export function AuthProvider({ children }) {
  const [session, setSession]   = useState(null)
  const [profile, setProfile]   = useState(null)
  const [role, setRole]         = useState(null)
  const [loading, setLoading]   = useState(true)
  const isDemoRef = useRef(false)
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (isDemoRef.current) return
      setSession(session)
      if (session) fetchProfile(session.user.id)
      else setLoading(false)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (isDemoRef.current) return
      if (event === 'SIGNED_IN') {
        setSession(session)
        if (session) fetchProfile(session.user.id)
      } else if (event === 'SIGNED_OUT') {
        setSession(null)
        setProfile(null)
        setRole(null)
        setLoading(false)
      }
    })
    return () => subscription.unsubscribe()
  }, [])
  async function fetchProfile(userId) {
    const { data } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single()
    setProfile(data)
    setRole(data?.role || 'employee')
    setLoading(false)
  }
  async function signIn(email, password) {
    return supabase.auth.signInWithPassword({ email, password })
  }
  async function signOut() {
    isDemoRef.current = false
    await supabase.auth.signOut()
    setProfile(null)
    setRole(null)
    setSession(null)
    window.location.href = '/login'
  }
  function signInDemo(asRole = 'employee') {
    isDemoRef.current = true
    const demoProfiles = {
      owner:      { first_name:'Tiffany', last_name:'Gallagher', role:'owner',      department:'Executive',      demo_mode:true },
      hr_admin:   { first_name:'Kim',     last_name:'Park',      role:'hr_admin',   department:'Administrative', demo_mode:true },
      supervisor: { first_name:'Sam',     last_name:'Rivera',    role:'supervisor', department:'Operations',     demo_mode:true },
      employee:   { first_name:'Jamie',   last_name:'Mitchell',  role:'employee',   department:'Operations',     demo_mode:true },
      admin:      { first_name:'Tiffany', last_name:'Gallagher', role:'admin',      department:'Executive',      demo_mode:true },
    }
    const demoProfile = { id:'demo-user', ...(demoProfiles[asRole] || demoProfiles.employee) }
    setSession({ user: { id: 'demo-user' } })
    setProfile(demoProfile)
    setRole(demoProfile.role)
    setLoading(false)
  }
  function switchDemoRole() {
    isDemoRef.current = true
    const currentRole = profile?.role || role
    const newRole = (currentRole === 'admin' || currentRole === 'owner' || currentRole === 'hr_admin' || currentRole === 'supervisor') ? 'employee' : 'admin'
    signInDemo(newRole)
    return newRole
  }
  return (
    <AuthContext.Provider value={{ session, profile, role, loading, signIn, signOut, signInDemo, switchDemoRole }}>
      {children}
    </AuthContext.Provider>
  )
}
export const useAuthContext = () => useContext(AuthContext)
